import gql from 'graphql-tag';

export const taskFilterOptionsQuery = gql`
  query taskFilterOptions(
    $groupIds: [String]!
    $options: [TaskFilterOptionType!]!
  ) {
    taskFilterOptions(groupIds: $groupIds, options: $options) {
      equipment {
        name
        id
      }
      schedule {
        name
        id
      }
      status
      assignee {
        _id
        name
        profile {
          name
        }
      }
      transitionStatus
    }
  }
`;
